export const LOGIN = "/login";
export const SET_PASSWORD_PAGE = "/set-password";
export const DASHBOARD = "/";
export const INVENTORY ="/inventory";
export const REQUESTS = "/requests"; 
export const SUPPLIER = "/supplier";
export const USERS = "/users";
export const TOOLS = "/tools";
export const ORGANIZATION = "/organization";
export const PROFILE = "/profile";
export const GLOBAL_SEARCH = "/global-seach";